module["exports"] = [
  "??# #??",
  "??## #??",
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/en_GB/address/postcode.js
// module id = 1011
// module chunks = 0